<template>
  <!--
    2026-07-21: shared section-header — introduced during the "complete
    revamp" pass so every section across all 3 wizard steps (and the
    document itself, structurally) reads with ONE consistent visual
    language (icon-in-circle + uppercase title + optional badge/subtitle +
    divider) instead of each step having grown its own slightly different
    ad hoc heading style (<h5>, <h6 class="text-uppercase">, plain <h6>,
    etc.) as separate passes touched them independently this session.
  -->
  <div class="wizard-section-header d-flex align-items-center flex-wrap" :class="{ 'mt-4': spaced, 'is-compact': compact }">
    <span class="wizard-section-icon mr-2" :class="'variant-' + variant">
      <feather-icon :icon="icon" size="13" />
    </span>
    <span class="wizard-section-title">{{ title }}</span>
    <b-badge v-if="badge" :variant="badgeVariant" class="ml-2">{{ badge }}</b-badge>
    <span v-if="subtitle" class="text-muted small ml-2">{{ subtitle }}</span>
    <div class="flex-grow-1 ml-2 wizard-section-rule" />
  </div>
</template>

<script>
import { BBadge } from 'bootstrap-vue'

export default {
  name: 'WizardSectionHeader',
  components: { BBadge },
  props: {
    icon: { type: String, default: 'CircleIcon' },
    title: { type: String, required: true },
    subtitle: { type: String, default: '' },
    badge: { type: String, default: '' },
    badgeVariant: { type: String, default: 'light-info' },
    // 'primary' (default section rhythm) vs 'muted' (secondary/optional
    // sections, e.g. Reference Codes, Supporting Document) — a lighter
    // touch than a whole separate component per variant.
    variant: { type: String, default: 'primary' },
    // Adds top margin — used between stacked sections within one step;
    // the first section in a step passes false since the step's own
    // heading/intro paragraph already provides top spacing.
    spaced: { type: Boolean, default: true },
    compact: { type: Boolean, default: false },
  },
}
</script>

<style scoped>
.wizard-section-header {
  margin-bottom: 0.65rem;
}
.wizard-section-header.is-compact {
  margin-bottom: 0.35rem;
}
.wizard-section-header.is-compact .wizard-section-icon {
  width: 18px;
  height: 18px;
}
.wizard-section-header.is-compact .wizard-section-title {
  font-size: 0.72rem;
}
.wizard-section-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 22px;
  height: 22px;
  border-radius: 50%;
  flex-shrink: 0;
}
.wizard-section-icon.variant-primary {
  background-color: rgba(0, 172, 153, 0.12);
  color: #00AC99;
}
.wizard-section-icon.variant-muted {
  background-color: rgba(110, 107, 123, 0.1);
  color: #6e6b7b;
}
.wizard-section-title {
  font-size: 0.78rem;
  font-weight: 700;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  color: #5e5873;
}
.wizard-section-rule {
  border-bottom: 1px dashed #ebe9f1;
  min-width: 24px;
  height: 1px;
  align-self: center;
}
</style>
